import {ACTIONS} from "@intellectability/platform-common/constants";

/** @type {import("@intellectability/platform-common/router").RouterConfig} */
const routerConfig = {
    spa: false,
    appPath: "index.php",
    routes: [
        {
            layout: "null",
            path: `?action=${ACTIONS.CHECKLISTS_SCIPR_GLOBAL_LIST}`,
            render: () => import("../../Pages/Nursing/SciprList/SciprList.svelte"),
            title: "SCIP-R List"
        }
    ]
};

export default routerConfig;
